import Appsignal from '@appsignal/javascript';

export default new Appsignal({
  key: 'e57ac18c-dc60-4653-adc2-70c610c252ea'
});
